<div *ngIf="totalLoader > 0" class="overlay">
  <div class="center text-white">
    <div class="spinner-border" role="status"></div>
    <span>Cargando...</span>
  </div>
</div>
